import { useState } from 'react';

import { Users } from '../../../api-calls';
import {
  Button,
  Grid,
  Inputs as I,
  Modal,
  Typography as T,
} from '../../../components';
import { useAuth } from '../../../context/auth';
import * as S from './style';

import { navRoutes } from '../../../constants';

import { useNavigate } from 'react-router-dom';

const { Row, Col } = Grid;

const ConfirmDeletion = () => {
  const { user, logout } = useAuth();
  const [userEmailInput, setUserEmailInput] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [httpError, setHttpError] = useState('');
  const navigate = useNavigate();

  const handleDelete = async () => {
    setLoading(true);
    const { error } = await Users.deleteUser({
      id: user.id,
    });

    setLoading(false);

    if (error) {
      setHttpError(error.message);
    } else {
      // console.log('every thing is good');
      setIsModalVisible(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleDelete();
  };

  return (
    <S.Form onSubmit={handleSubmit}>
      <Row>
        <Col w={[4, 12, 12]}>
          <T.H1 mb="6" weight="bold">
            Confirm deletion
          </T.H1>
        </Col>{' '}
        <Col w={[4, 12, 10]}>
          <T.P color="neutralMain">
            Are you sure you wish to delete your account? This will permanently
            remove your profile, log in and all account details.
          </T.P>
        </Col>
      </Row>
      <Row>
        <Col w={[4, 12, 8]} mt={6}>
          <T.P mb="2" color="neutralMain">
            Type <span style={{ fontWeight: 'bold' }}>{user.email}</span> to
            confirm
          </T.P>
          <I.BasicInput
            type="text"
            placeholder="Type your email..."
            value={userEmailInput}
            handleChange={(value) => setUserEmailInput(value)}
          />
        </Col>
      </Row>

      <Row mt={6}>
        <Col w={[4, 12, 8]} style={{ alignItems: 'flex-end' }}>
          {httpError && (
            <T.P mb={2} color="error">
              {httpError}
            </T.P>
          )}

          <Button
            variant="primary"
            disabled={
              userEmailInput.toLowerCase().trim() !==
              user.email.toLowerCase().trim()
            }
            loading={loading}
            text="I understand, delete my account"
            type="submit"
          />
        </Col>
      </Row>

      <Modal
        visible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        title={'Account deleted'}
        parentFunc={() => {
          logout();
          navigate(navRoutes.GENERAL.HOME);
        }}
        onCancel={() => {
          logout();
          navigate(navRoutes.GENERAL.HOME);
        }}
        description={'Your account has now been successfully deleted. '}
        btnText="Return home"
      />
    </S.Form>
  );
};

export default ConfirmDeletion;
